import { css } from "@emotion/react";

export const partnerStyles = (theme) => css`
  margin: 0 auto;
  width: 100%;
  max-width: 1180px;
  padding: 0 0.5rem 0.5rem;

  .slick-prev,
  .slick-next {
    width: 44px;
    height: 44px;
    z-index: 2;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    appearance: none;
    -webkit-appearance: none;
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  .slick-prev:hover,
  .slick-next:hover,
  .slick-prev:focus,
  .slick-next:focus,
  .slick-prev:active,
  .slick-next:active {
    background: transparent !important;
    box-shadow: none !important;
  }

  .slick-prev:before,
  .slick-next:before {
    content: none !important;
    display: none !important;
  }

  .arrow-button {
    color: #000000;
    font-size: 1.15rem;
    background: transparent !important;
    border: 0 !important;
    border-radius: 0 !important;
    padding: 0 !important;
    box-shadow: none !important;
    cursor: pointer;
  }

  .arrow-button svg {
    display: block;
  }

  .slick-next {
    right: 0;
  }

  .slick-prev {
    left: 0;
  }

  .partners {
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: stretch;
    padding: 0;
    width: 100%;
  }

  .slick-slider {
    width: 100%;
    margin: auto;
  }

  .slick-slide {
    height: auto;
  }

  .slick-slide > div {
    height: 100%;
    padding: 0 0.75rem;
  }

  .slick-track {
    display: flex;
    align-items: stretch;
  }

  button:active {
    box-shadow: none !important;
    transform: none;
    outline: none;
  }

  .slick-dots {
    width: 100%;
  }
  .slick-dots li {
    width: 18px;
  }
  .slick-dots button {
    width: 36px;
    padding: 24px;
    font-size: 0;
  }
  .slick-dots li button:before {
    font-size: 10px;
    line-height: 30px;
    color: ${theme.dark ? "#689DDE" : "#7a8792"};
  }
  .slick-dots li.slick-active button:before {
    color: ${theme.dark ? "#689DDE" : "#313841"};
  }

  @media (max-width: 1300px) {
    a {
      margin: 0;
      padding: 0;
    }
    .partners {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      text-align: center;
      align-items: center;
    }
    .slick-slider {
      margin: auto;
      width: 100%;
    }
  }

  @media (max-width: 700px) {
    .partners {
      width: 100%;
      margin: 0;
    }
    .right-arrow,
    .left-arrow {
      display: none;
    }
    .slick-slider {
      margin-left: 0;
      padding: 0;
    }
    .slick-dots li button:before {
      font-size: 9px;
      line-height: 60px;
    }
  }
`;
